// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__o1XJf"};